<template>
  <v-container fluid fill-height align-start ma-0 pa-2>
    <v-row no-gutters>
      <hr-select-pop-up
        :key="componentKey"
        :popupVisible="popupVisible"
        :defaultHrList="selectedHrList"
        :cellInfo="selectedCellInfo"
        @apply="onHrSelectorApply"
        @popupClose="popupVisible = false"
      />
      <v-col cols="12" sm="12" lg="12" class="pa-2 pb-0">
        <i-card-top
          class="d-md-flex"
          headerTitle=""
          :useBtnList="buttonUseList"
          @btnSearch="btnSearch(true)"
          @btnAdd="btnAdd()"
          @btnSave="btnSave()"
          @btnDelete="btnDelete()"
          @btnPrint="btnPrint"
        >
          <template v-slot:body>
            <v-layout>
              <v-row no-gutters class="pa-0 pt-2">
                <v-col cols="12" md="4">
                  <v-row no-gutters>
                    <v-col>
                      <i-date-time-picker
                        :firstDisplayDate="startDate"
                        label="보고일자"
                        class="mx-1"
                        :dateOnly="true"
                        @getDate="setSearchDate($event, 'start')"
                      >
                      </i-date-time-picker>
                    </v-col>
                    <span class="py-2">
                      ~
                    </span>
                    <v-col>
                      <i-date-time-picker
                        :firstDisplayDate="endDate"
                        label="보고일자"
                        class="mx-1"
                        :dateOnly="true"
                        @getDate="setSearchDate($event, 'end')"
                      >
                      </i-date-time-picker>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" md="3" class="py-2 py-md-0">
                  <v-select
                    :menu-props="{ offsetY: true }"
                    class="mx-1"
                    item-text="minorNm"
                    item-value="minorCd"
                    :items="selectDiv"
                    placeholder="조사구분"
                    dense
                    outlined
                    v-model="selectedDiv"
                  />
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field
                    :placeholder="$t('totalSearch')"
                    class="mx-1 pt-2 py-md-0"
                    dense
                    outlined
                    hide-details="auto"
                    @change="changeInput"
                    clearable
                  />
                </v-col>
              </v-row>
            </v-layout>
          </template>
        </i-card-top>
      </v-col>
      <v-col cols="12" sm="12" lg="12" class="pa-2 pt-0">
        <i-card-vertical :headerTitle="$t('muscleHazardSearchList')" device="web">
          <template v-slot:body>
            <v-layout column>
              <v-col cols="12" md="12" class="row pa-0">
                <v-col cols="12" lg="12" class="pa-0 ">
                  <DxDataGrid
                    id="muscleHazardSearchDataGrid"
                    class="layout-col-height00"
                    width="100%"
                    :ref="dxDataGridRef"
                    :data-source="gridMain"
                    :hover-state-enabled="true"
                    :allow-column-resizing="true"
                    :allow-column-reordering="true"
                    :column-auto-width="false"
                    :show-borders="true"
                    :show-row-lines="true"
                    :focused-row-enabled="true"
                    key-expr="id"
                    @editing-start="onEditingStart"
                    @editor-preparing="onEditorPreparing"
                    @focused-row-changed="onFocusedRowChanged"
                    @row-prepared="onRowPrepared"
                  >
                    <DxScrolling row-rendering-mode="standard" />

                    <DxEditing mode="batch" :allow-updating="true" :select-text-on-edit-start="true" />

                    <DxSelection select-all-mode="allMode" show-check-boxes-mode="always" mode="multiple" />

                    <DxColumn data-field="compId" data-type="string" :visible="false"> </DxColumn>

                    <DxColumn data-field="seq" data-type="int" :visible="false"> </DxColumn>
                    <DxColumn
                      data-field="checkMuscleHazardM"
                      caption="작업조건 조사여부"
                      data-type="string"
                      cell-template="symptonSearchTemplate"
                      :allow-editing="false"
                      width="120px"
                      header-cell-template="title-header2"
                      alignment="center"
                    />
                    <template #title-header2="{ }">
                      <div>{{ $t('workCondition') }}<br />{{ $t('searchYn') }}</div>
                    </template>
                    <template #symptonSearchTemplate="{data:cellInfo}">
                      <v-row no-gutters class="pr-1" style="flex-flow: nowrap;">
                        <v-col align="center">
                          <svg-icon v-if="cellInfo.row.data.checkMuscleHazardM" icon-class="check_circle" style=""></svg-icon>
                        </v-col>
                      </v-row>
                    </template>
                    <DxColumn
                      data-field="searchGubn"
                      :caption="$t('searchDiv')"
                      width="150px"
                      data-type="string"
                      alignment="left"
                      css-class="devest-grid-header-require"
                    >
                      <DxLookup :data-source="searchGubnList" value-expr="minorCd" display-expr="minorNm" />
                    </DxColumn>
                    <DxColumn
                      data-field="occanCuase"
                      :caption="$t('occasionalCause')"
                      width="250px"
                      data-type="string"
                      alignment="left"
                      :calculate-display-value="e => parseOccanCuase(e.occanCuase)"
                      edit-cell-template="OccanCuaseEditor"
                    >
                    </DxColumn>
                    <template #OccanCuaseEditor="{ data: cellInfo }">
                      <DxTagBox
                        :data-source="occanCuaseList"
                        :v-model="setTagBoxValue(cellInfo.value)"
                        :value="setTagBoxValue(cellInfo.value)"
                        :show-selection-controls="true"
                        display-expr="minorNm"
                        value-expr="minorCd"
                        :search-enabled="true"
                        @value-changed="onTagValueChanged($event, cellInfo)"
                      >
                      </DxTagBox>
                    </template>

                    <DxColumn
                      data-field="searchDate"
                      :caption="$t('searchDate')"
                      width="150px"
                      data-type="date"
                      format="yyyy.MM.dd"
                      alignment="center"
                      edit-cell-template="dateEditor"
                      css-class="devest-grid-header-require"
                    >
                    </DxColumn>
                    <template #dateEditor="{ data: cellInfo}">
                      <div>
                        <DxDateBox
                          :value="cellInfo.value"
                          type="date"
                          picker-type="calendar"
                          display-format="yyyy.MM.dd"
                          :use-mask-behavior="true"
                          @value-changed="onDateValueChanged($event, cellInfo)"
                        />
                      </div>
                    </template>

                    <DxColumn data-field="wokerOrg" data-type="int" :visible="false"> </DxColumn>

                    <DxColumn
                      data-field="searchMem"
                      :caption="$t('searchMem')"
                      width="120px"
                      data-type="string"
                      alignment="left"
                      css-class="devest-grid-header-require"
                      edit-cell-template="hrSearchMemEditor"
                      header-cell-template="hrSearchHeader"
                    >
                      <DxLookup :data-source="hrListForSearch" value-expr="searchMem" display-expr="korNm" />
                    </DxColumn>
                    <template #hrSearchMemEditor="{ data: cellInfo }">
                      <DevLookup
                        :value="cellInfo.value"
                        :data-source="hrListForSearch"
                        value-expr="searchMem"
                        display-expr="korNm"
                        :item-template="itemTemplateHr"
                        @value-changed="e => onHrNoValueChanged(e, cellInfo)"
                      >
                      </DevLookup>
                    </template>
                    <template #hrSearchHeader>
                      <span>
                        {{ $t('searchMem') }}
                        <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon small v-bind="attrs" v-on="on" class="mx-1">
                              mdi-help-circle
                            </v-icon>
                          </template>
                          <span> {{ $t('authGroup') }} : {{ $t('safetyManager') }} </span>
                        </v-tooltip>
                      </span>
                    </template>
                    <DxColumn
                      data-field="deptCode"
                      :caption="$t('deptName')"
                      width="160px"
                      data-type="string"
                      alignment="left"
                      css-class="devest-grid-header-require"
                    >
                      <DxLookup :data-source="deptCodeList" value-expr="minorCd" display-expr="minorNm" />
                    </DxColumn>

                    <DxColumn
                      data-field="processId"
                      :caption="$t('workProcessNm')"
                      width="180px"
                      data-type="string"
                      alignment="left"
                      css-class="devest-grid-header-require"
                    >
                      <DxLookup :data-source="proDataSource" value-expr="checkId" display-expr="checkTargetNm" />
                    </DxColumn>

                    <DxColumn
                      data-field="woker"
                      :caption="$t('worker')"
                      width="120px"
                      data-type="string"
                      alignment="left"
                      css-class="devest-grid-header-require"
                      edit-cell-template="hrWokerEditor"
                    >
                      <DxLookup :data-source="hrList" value-expr="woker" display-expr="korNm" />
                    </DxColumn>

                    <template #hrWokerEditor="{ data: cellInfo }">
                      <DevLookup
                        :value="cellInfo.value"
                        :data-source="hrList"
                        value-expr="woker"
                        display-expr="korNm"
                        :item-template="itemTemplateHr"
                        @value-changed="e => onHrNoValueChanged(e, cellInfo)"
                      >
                      </DevLookup>
                    </template>

                    <DxColumn
                      data-field="workName"
                      :caption="$t('workName')"
                      width="200px"
                      data-type="string"
                      alignment="left"
                      css-class="devest-grid-header-require"
                    >
                    </DxColumn>

                    <template #dateBoxEditor="{ data }">
                      <DxDateBox
                        :value="getDateToTime(data.value)"
                        type="time"
                        display-format="HH:mm"
                        :use-mask-behavior="true"
                        :buttons="[]"
                        @input="ignoreKorean($event, dxDataGridRef)"
                        @value-changed="onTimeValueChanged($event, data)"
                      />
                    </template>

                    <DxColumn
                      data-field="situationFacilityContent"
                      :caption="`${$t('placeSituation')}(${$t('workEquip')})`"
                      width="300px"
                      alignment="left"
                      cell-template="situationFacilityEditor"
                      edit-cell-template="situationFacilityEditor"
                    >
                    </DxColumn>
                    <template #situationFacilityEditor="{ data: cellInfo }">
                      <v-row no-gutters>
                        <v-col cols="5">
                          <DxSelectBox
                            :data-source="ynList"
                            value-expr="code"
                            display-expr="name"
                            v-model="cellInfo.data.situationFacilityYn"
                            @value-changed="onCustomValueChanged($event, cellInfo)"
                          ></DxSelectBox>
                        </v-col>
                        <v-col cols="7">
                          <DxTextBox
                            v-model="cellInfo.data.situationFacilityContent"
                            @value-changed="onCustomValueChanged($event, cellInfo)"
                            placeholder="내용없음"
                          ></DxTextBox>
                        </v-col>
                      </v-row>
                    </template>

                    <DxColumn
                      data-field="situationWorkloadContent"
                      :caption="`${$t('placeSituation')}(${$t('workLoad')})`"
                      width="300px"
                      alignment="left"
                      cell-template="situationWorkloadEditor"
                      edit-cell-template="situationWorkloadEditor"
                    >
                    </DxColumn>
                    <template #situationWorkloadEditor="{ data: cellInfo }">
                      <v-row no-gutters>
                        <v-col cols="5">
                          <DxSelectBox
                            :data-source="ynList"
                            value-expr="code"
                            display-expr="name"
                            v-model="cellInfo.data.situationWorkloadYn"
                            @value-changed="onCustomValueChanged($event, cellInfo)"
                          ></DxSelectBox>
                        </v-col>
                        <v-col cols="7">
                          <DxTextBox
                            v-model="cellInfo.data.situationWorkloadContent"
                            @value-changed="onCustomValueChanged($event, cellInfo)"
                            placeholder="내용없음"
                          ></DxTextBox>
                        </v-col>
                      </v-row>
                    </template>

                    <DxColumn
                      data-field="situationWorkspeedContent"
                      :caption="`${$t('placeSituation')}(${$t('workSpeed')})`"
                      width="300px"
                      alignment="left"
                      cell-template="situationWorkspeedEditor"
                      edit-cell-template="situationWorkspeedEditor"
                    >
                    </DxColumn>
                    <template #situationWorkspeedEditor="{ data: cellInfo }">
                      <v-row no-gutters>
                        <v-col cols="5">
                          <DxSelectBox
                            :data-source="ynList"
                            value-expr="code"
                            display-expr="name"
                            v-model="cellInfo.data.situationWorkspeedYn"
                            @value-changed="onCustomValueChanged($event, cellInfo)"
                          ></DxSelectBox>
                        </v-col>
                        <v-col cols="7">
                          <DxTextBox
                            v-model="cellInfo.data.situationWorkspeedContent"
                            @value-changed="onCustomValueChanged($event, cellInfo)"
                            placeholder="내용없음"
                          ></DxTextBox>
                        </v-col>
                      </v-row>
                    </template>

                    <DxColumn
                      data-field="situationWorktypeContent"
                      :caption="`${$t('placeSituation')}(${$t('workType')})`"
                      width="300px"
                      alignment="left"
                      cell-template="situationWorktypeEditor"
                      edit-cell-template="situationWorktypeEditor"
                    >
                    </DxColumn>
                    <template #situationWorktypeEditor="{ data: cellInfo }">
                      <v-row no-gutters>
                        <v-col cols="5">
                          <DxSelectBox
                            :data-source="ynList"
                            value-expr="code"
                            display-expr="name"
                            v-model="cellInfo.data.situationWorktypeYn"
                            @value-changed="onCustomValueChanged($event, cellInfo)"
                          ></DxSelectBox>
                        </v-col>
                        <v-col cols="7">
                          <DxTextBox
                            v-model="cellInfo.data.situationWorktypeContent"
                            @value-changed="onCustomValueChanged($event, cellInfo)"
                            placeholder="내용없음"
                          ></DxTextBox>
                        </v-col>
                      </v-row>
                    </template>

                    <DxColumn
                      data-field="situationWorketcContent"
                      :caption="`${$t('placeSituation')}(${$t('etc')})`"
                      width="300px"
                      alignment="left"
                      cell-template="situationWorketcEditor"
                      edit-cell-template="situationWorketcEditor"
                    >
                    </DxColumn>
                    <template #situationWorketcEditor="{ data: cellInfo }">
                      <v-row no-gutters>
                        <v-col cols="5">
                          <DxSelectBox
                            :data-source="ynList"
                            value-expr="code"
                            display-expr="name"
                            v-model="cellInfo.data.situationWorketcYn"
                            @value-changed="onCustomValueChanged($event, cellInfo)"
                          ></DxSelectBox>
                        </v-col>
                        <v-col cols="7">
                          <DxTextBox
                            v-model="cellInfo.data.situationWorketcContent"
                            @value-changed="onCustomValueChanged($event, cellInfo)"
                            placeholder="내용없음"
                          ></DxTextBox>
                        </v-col>
                      </v-row>
                    </template>

                    <DxColumn
                      data-field="workContent"
                      :caption="$t('workContent')"
                      width="200px"
                      data-type="string"
                      alignment="left"
                      cell-template="sub-dx-datagrid"
                      edit-cell-template="sub-dx-datagrid"
                    >
                    </DxColumn>

                    <DxColumn
                      data-field="evaluationResultContent"
                      :caption="$t('evaluationResultContent')"
                      width="120px"
                      data-type="string"
                      alignment="left"
                      cell-template="sub-dx-datagrid"
                      edit-cell-template="sub-dx-datagrid"
                    >
                    </DxColumn>

                    <DxColumn data-field="remark" :caption="$t('remark')" data-type="string" width="100px" alignment="left"> </DxColumn>

                    <DxMasterDetail :enabled="true" template="master-detail" />

                    <template #master-detail="{ data }">
                      <MuscleHazardSearchDetail :detailRef="`dxMasterDetailRef${data.data.seq}`" :master-detail-data="data" />
                    </template>

                    <template #checkBoxEditor="{ data: cellInfo }">
                      <DxCheckBox :value="cellInfo.value == 'Y' ? true : false" :onValueChanged="value => onCheckValueChanged(value, cellInfo)" />
                    </template>

                    <template #sub-dx-datagrid="{ data: cellInfo }">
                      <div>
                        <!-- :min-height="55" -->
                        <DxTextArea
                          :ref="`subDxTextAra${cellInfo.row.rowIndex}`"
                          :auto-resize-enabled="true"
                          v-model="cellInfo.value"
                          :on-value-changed="
                            e => {
                              cellInfo.setValue(e.value, e.value)
                              cellInfo.component.selectRows(cellInfo.row.key, true)
                            }
                          "
                          :on-key-down="
                            e => {
                              if (e.event.keyCode == 13) {
                                e.event.stopPropagation()
                              }
                            }
                          "
                        />
                      </div>
                    </template>

                    <template #fileTemplate="{ data }">
                      <v-icon small v-if="data.value == 'Y'" class="file_icon">
                        mdi-paperclip
                      </v-icon>
                    </template>
                  </DxDataGrid>
                </v-col>
              </v-col>
            </v-layout>
          </template>
        </i-card-vertical>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {
  deleteMuscleHazardSearch,
  getMuscleHazardSearch,
  getMuscleHazardSearchReport,
  saveMuscleHazardSearch
} from '@/api/healthcare/muscleHazardSearch'
import iCardTop from '@/components/common/iCardTop.vue'
import iCardVertical from '@/components/common/iCardVertical.vue'
import iDateTimePicker from '@/components/common/iDateTimePicker.vue'
import DxCheckBox from 'devextreme-vue/check-box'
import { DxColumn, DxDataGrid, DxLookup, DxMasterDetail, DxSelection } from 'devextreme-vue/data-grid'
import DxDateBox from 'devextreme-vue/date-box'
import { DxLookup as DevLookup, DxDropDownOptions } from 'devextreme-vue/lookup'
import DxTagBox from 'devextreme-vue/tag-box'
import DxTextBox from 'devextreme-vue/text-box'

import MuscleHazardSearchDetail from './MuscleHazardSearch_Detail.vue'

import { getMuscleSymptonHrInfo, getMuscleSymptonHrSearchInfo } from '@/api/healthcare/muscleSymptonSearch'
import { multiUpload } from '@/api/baseManage/fileUpload'

import { getDateTimeFormat, getDateToTime, getPreMonth } from '@/utils/common.js'

import HrSelectPopUp from '@/components/common/hrSelectPopUp.vue'
import BaseDataGrid from '@/views/base/BaseDataGrid.vue' //20220509 LYJ 데이타 그리드 사용시 베이스 추가
import baseview from '@/views/base/baseview.vue' //20220414 LYJ base page 추가

import { getCheckIdLookup } from '@/api/baseManage/checkInfo'
import { getCommonCode } from '@/api/common/commonApi'

import { getHrApi } from '@/api/baseManage/esgHRManage'
import DxSelectBox from 'devextreme-vue/select-box'

export default {
  mixins: [baseview, BaseDataGrid], //20220414 LYJ base page 추가 및 권한 처리
  components: {
    DxCheckBox,
    DxTextBox,
    DxTagBox,
    DxDateBox,
    'i-date-time-picker': iDateTimePicker,
    'i-card-vertical': iCardVertical,
    'i-card-top': iCardTop,
    DxDataGrid,
    DxColumn,
    DxMasterDetail,
    DxSelection,
    MuscleHazardSearchDetail,
    HrSelectPopUp,
    DxLookup,
    DevLookup,
    DxSelectBox
  },
  data() {
    return {
      dxDataGridRef: 'muscleHazardSearchDataGrid',
      gridMain: [],
      buttonUseList: [
        'btnSearch', //조회
        'btnAdd', //추가
        'btnSave', //저장
        'btnDelete', //삭제
        'btnPrint' // 출력
      ],
      txtsearchGubn: '',
      txtMuscleHazardSearchPlace: '',

      //조사구분
      selectDiv: [],
      selectedDiv: '',

      startDate: getPreMonth(12),
      endDate: getPreMonth(0),

      searchStartDate: getPreMonth(12).replace(/[^0-9]/g, ''),
      searchEndDate: getPreMonth(0).replace(/[^0-9]/g, ''),

      hrList: [],
      hrListForSearch: [],
      popupVisible: false,
      selectedCellInfo: null,
      selectedHrList: [],
      componentKey: 0,

      //조사자
      esgHrNoListSearchMem: [],
      esgHrNoListLookupSearchMem: [],
      esgHrNoListSourceSearchMem: [],

      //근로자
      esgHrNoListWoker: [],
      esgHrNoListLookupWoker: [],
      esgHrNoListSourceWoker: [],

      searchGubnList: [], //조사구분(공통코드:C0045)
      occanCuaseList: [], //수시작업시 사유(공통코드:C0046)
      deptCodeList: [], //부서명(공통코드:C0053)

      proDataSource: [], //공정

      ynList: [
        { code: 'Y', name: '변화 있음' },
        { code: 'N', name: '변화 없음' }
      ], //변화유무(변화있음:Y,변화없음:N)

      saveDetailList: [], // 근골격계 유해요인 상세 데이터 저장
      updateReq: false,
      detailDataList: []
    }
  },
  beforeMount() {
    this.getLookupData()

    this.setComboBoxData()

    if (this.$route.params && this.$route.params.focusedRowKey != null) {
      this.btnSearch().then(res => {
        if (this.$route.params.focusedRowKey) this.GetDataGrid(this.dxDataGridRef).option('focusedRowKey', this.$route.params.focusedRowKey)
      })
    }
  },
  mounted() {
    this.btnSearch(true)
  },
  activated() {},
  watch: {
    $route(to, from) {
      if (to.path == '/2048' && to.path != from.path) {
        this.getLookupData()
      }
    }
  },
  methods: {
    onRowPrepared(e) {
      if (e.rowType == 'data' && e.data.__created__) {
        let row = e.rowElement.querySelector('.dx-command-expand')
        if (row == null) return
        row.firstChild.classList.remove('dx-datagrid-group-closed')
        row.style.pointerEvents = 'none'
      }
    },

    forceRerender() {
      this.componentKey += 1
    },
    setComboBoxData() {
      Promise.all([getHrApi({ compId: this.getCompId(), grouped: '조사자' }), getHrApi({ compId: this.getCompId(), grouped: '근로자' })]).then(
        response => {
          //조사자
          this.esgHrNoListSearchMem = []
          this.esgHrNoListSearchMem = response[0].list.slice()
          var esgHrNoListSourceSearchMem = response[0].list.filter(element => element.key !== '기타' && element.key !== '전체')
          this.esgHrNoListLookupSearchMem = esgHrNoListSourceSearchMem.reduce((acc, val) => acc.concat(val.items), [])

          //근로자
          this.esgHrNoListWoker = []
          this.esgHrNoListWoker = response[1].list.slice()
          var esgHrNoListSourceWoker = response[1].list.filter(element => element.key !== '기타' && element.key !== '전체')
          this.esgHrNoListLookupWoker = esgHrNoListSourceWoker.reduce((acc, val) => acc.concat(val.items), [])
        }
      )
    },
    ///////////////////////////////////////
    /*       Toolbar Button Event        */
    ///////////////////////////////////////
    setSearchDate(e, div) {
      if (div === 'start') {
        this.searchStartDate = e.replace(/[^0-9]/g, '')
      } else if (div === 'end') {
        this.searchEndDate = e.replace(/[^0-9]/g, '')
      }
    },
    formatDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${year}${month}${day}`
    },
    btnAdd() {
      let newRow = {
        id: this.gridMain.length + 1,
        compId: this.getCompId(),
        searchMem: null, //조사자
        muscleHazardSearchDate: getPreMonth(0),
        situationFacilityYn: 'N', //작업장상황조사(작업설비)
        situationWorkloadYn: 'N', //작업장상황조사 (작업량)
        situationWorkspeedYn: 'N', //작업장상황조사 (작업속도)
        situationWorktypeYn: 'N', //작업장상황조사 (업무형태)
        situationWorketcYn: 'N' //작업장상황조사 (기타)
      }

      Object.defineProperty(newRow, '__created__', { value: true, writable: true, enumerable: true, configurable: true })
      this.GetDataGrid(this.dxDataGridRef).newRow(newRow)
      this.GetDataGrid(this.dxDataGridRef).selectRows(newRow.id, true)
    },
    async btnSearch(isNotice) {
      //this.gridInit(this.GetDataGrid(this.dxDataGridRef))
      this.openLoading('searching')

      let searchParams = {
        compId: this.getCompId(),
        searchGubn: this.selectedDiv,
        searchStartdate: this.searchStartDate.replace(/[^0-9]/g, ''),
        searchEnddate: this.searchEndDate.replace(/[^0-9]/g, '')
      }
      getMuscleHazardSearch(searchParams, isNotice)
        .then(res => {
          this.gridMain = res.list
          this.gridInit(this.GetDataGrid(this.dxDataGridRef))
          this.FocusFirstRow(this.GetDataGrid(this.dxDataGridRef))
          this.GetDataGrid(this.dxDataGridRef).option('scrolling', {
            legacyMode: true
          })
        })
        .finally(() => {
          this.endLoading()
        })
    },
    async btnSave() {
      this.GetDataGrid(this.dxDataGridRef).beginUpdate()
      this.GetDataGrid(this.dxDataGridRef).saveEditData()
      var selectedRows = await this.GetDataGrid(this.dxDataGridRef).getSelectedRowsData()
      if (selectedRows.length === 0) {
        this.vToastify(this.$t('selectionData'), 'warn')
        this.GetDataGrid(this.dxDataGridRef).endUpdate()
        return
      }
      let index = selectedRows.findIndex(
        element =>
          //조사구분
          element.searchGubn == null ||
          element.searchGubn == '' ||
          //조사일자
          element.searchDate == null ||
          element.searchDate == '' ||
          //부서명
          element.deptCode == null ||
          element.deptCode == '' ||
          //작업공정명
          element.processId == null ||
          element.processId == '' ||
          //작업명
          element.workName == null ||
          element.workName.trim() == '' ||
          //조사자
          element.searchMem == null ||
          element.searchMem == '' ||
          //근로자
          element.woker == null ||
          element.woker == ''
      )
      if (index >= 0) {
        this.vToastify(
          `${this.$t('msgReqValidate')}\n[${this.$t('searchDiv')},${this.$t('searchDate')},${this.$t('searchMem')},${this.$t('deptName')},${this.$t(
            'WorkProcessNm'
          )},${this.$t('worker')},${this.$t('workName')}]`,
          'warn'
        )

        //this.endLoading()
        this.GetDataGrid(this.dxDataGridRef).endUpdate()
        return
      }

      for (let i = 0; i < selectedRows.length; i++) {
        if (selectedRows[i].occanCuase === null || selectedRows[i].occanCuase === '' || selectedRows[i].occanCuase === undefined) {
          if (selectedRows[i].searchGubn === 'occasional') {
            this.vToastify(this.$t('수시점검인 경우 수시작업 사유를 입력해주세요.'), 'warn')
            //this.endLoading()
            this.GetDataGrid(this.dxDataGridRef).endUpdate()
            return
          }
        }
      }
      this.GetDataGrid(this.dxDataGridRef).endUpdate()

      this.vToastifyPrompt(
        this.$t('doSaveData'),
        'info',
        current => {
          this.openLoading('saving')
          saveMuscleHazardSearch(selectedRows, true)
            .then(res => {
              if (res.code === -2000) {
                this.vToastify(this.$t('중복된 데이터가 있습니다. \n [조사구분, 수시작업사유, 조사일자, 부서명, 작업공정명, 근로자]'), 'warn')
              } else {
                this.btnSearch(false)
              }
            })
            .finally(() => {
              this.endLoading()
            })
        },
        null, // vToastify 아니요를 선택한 경우
        true // vToastify 예, 아니요 버튼 표시 여부 -> TODO: 이거 아닌거 같은데 확인해야됨
      )
    },
    closeVtoastifyPrompt() {
      this.GetDataGrid(this.dxDataGridRef).endUpdate()
    },

    async btnDelete() {
      this.GetDataGrid(this.dxDataGridRef).beginUpdate()
      this.GetDataGrid(this.dxDataGridRef).saveEditData()
      var selectedRows = await this.GetDataGrid(this.dxDataGridRef).getSelectedRowsData()
      if (selectedRows.length === 0) {
        this.vToastify(this.$t('selectionData'), 'warn')
        this.GetDataGrid(this.dxDataGridRef).endUpdate()
        return
      }

      this.vToastifyPrompt(
        this.$t('msgDelSearchList'),
        'info',
        current => {
          // 삭제할 데이터가 존재하지 않은 경우
          this.openLoading('deleting')
          deleteMuscleHazardSearch(selectedRows, true)
            .then(res => {
              this.deleteCallBack(selectedRows)
            })
            .finally(() => {
              this.btnSearch(false)
              this.GetDataGrid(this.dxDataGridRef).endUpdate()
              this.endLoading()
            })
        },
        this.closeVtoastifyPrompt.bind(this), // vToastify 아니요를 선택한 경우
        true
      )
    },

    async btnPrint(type) {
      let dataSource = this.GetDataGrid(this.dxDataGridRef).option('dataSource')
      let key = this.GetDataGrid(this.dxDataGridRef).option('keyExpr')
      let focusedRow = dataSource.find(row => row[key] == this.GetDataGrid(this.dxDataGridRef).option('focusedRowKey'))

      let msg = ''
      if (!focusedRow) {
        msg = '출력할 항목을 선택하세요.'
      }

      if (focusedRow.__created__) {
        msg = '저장되지 않은 항목은 출력 할 수 없습니다.'
      }

      if (msg !== '') {
        return this.vToastify(this.$t(msg), 'warn')
      }

      let selectedRows = []
      selectedRows.push(focusedRow)

      this.openLoading()

      let params = {
        voList: selectedRows,
        type: type
      }

      getMuscleHazardSearchReport(params)
        .then(res => {
          this.downloadReport(res)
        })
        .finally(res => {
          this.endLoading()
        })
    },
    ///////////////////////////////////////
    /*        DataGrid Event Event       */
    ///////////////////////////////////////
    setColumnSetting(e) {
      if (e.parentType == 'dataRow') {
        // 날짜 최소 최대
        if (e.dataField == 'muscleHazardSearchSt') {
          e.editorOptions.max = e.row.data.muscleHazardSearchEd
        }
        if (e.dataField == 'muscleHazardSearchEd') {
          e.editorOptions.min = e.row.data.muscleHazardSearchSt
        }
        // 총 시간은 음수가 될 수 없음
        if (e.dataField == 'muscleHazardSearchTime') {
          e.editorOptions.min = 0
        }
      }
    },
    onSelectFiles(e) {
      this.GetDataGrid(this.dxDataGridRef).selectRows(e.key, true)
    },
    parseOccanCuase(occanCuases) {
      if (!occanCuases) return ''

      let occanCuaseList = occanCuases.split(',')

      let occanCuase = this.occanCuaseList.filter(element => occanCuaseList.includes(element.minorCd))
      let resultArray = []
      occanCuase.forEach(element => resultArray.push(element.minorNm))
      return resultArray.join(', ')
    },
    // 참석대상에 string값을 배열값으로 변환시켜 넣어줌
    setTagBoxValue(value) {
      if (value != null) return value.split(',')
    },
    onCustomValueChanged(e, cellInfo) {
      cellInfo.component.selectRows(cellInfo.row.key, true)

      if (e.component.NAME == 'dxSelectBox') {
        if (cellInfo.column.dataField == 'situationFacilityContent' && cellInfo.data.situationFacilityYn == 'N') {
          cellInfo.data.situationFacilityContent = ''
        } else if (cellInfo.column.dataField == 'situationWorkloadContent' && cellInfo.data.situationWorkloadYn == 'N') {
          cellInfo.data.situationWorkloadContent = ''
        } else if (cellInfo.column.dataField == 'situationWorkspeedContent' && cellInfo.data.situationWorkspeedYn == 'N') {
          cellInfo.data.situationWorkspeedContent = ''
        } else if (cellInfo.column.dataField == 'situationWorktypeContent' && cellInfo.data.situationWorktypeYn == 'N') {
          cellInfo.data.situationWorktypeContent = ''
        } else if (cellInfo.column.dataField == 'situationWorketcContent' && cellInfo.data.situationWorketcYn == 'N') {
          cellInfo.data.situationWorketcContent = ''
        }
      }

      // cellInfo.data.situationFacilityContent = ''
    },
    onTagValueChanged(e, cellInfo) {
      cellInfo.setValue(e.value.join())
      cellInfo.component.selectRows(cellInfo.row.key, true)
    },
    onTimeValueChanged(e, cellInfo) {
      let display = getDateTimeFormat(e.value)
      let date = display != null ? display.substring(display.length - 5, display.length) : ''
      // 숫자만 남기기
      cellInfo.setValue(date)
      cellInfo.component.selectRows(cellInfo.row.key, true)
    },
    ShowPopup(cellInfo) {
      this.forceRerender()
      this.selectedCellInfo = cellInfo
      this.selectedHrList = cellInfo.data.muscleHazardSearchJoin
      this.popupVisible = true
    },
    onHrSelectorApply(selectedHrNo, cellInfo) {
      cellInfo.component.cellValue(cellInfo.row.rowIndex, 'muscleHazardSearchJoin', selectedHrNo)
      cellInfo.component.selectRows(cellInfo.row.key, true)
      this.popupVisible = false
    },
    // 조사자/근로자 선택시
    onHrNoValueChanged(e, cellInfo) {
      if (
        e.component
          .getDataSource()
          .items()
          .find(hr => hr[e.component.option('valueExpr')] == e.value)?.hrUseYn == 'N'
      ) {
        // 선택한 항목이 선택 불가능한 경우 선택 해제
        e.value = e.previousValue
      } else {
        cellInfo.component.selectRows(cellInfo.row.key, true)
      }
      cellInfo.setValue(e.value)
      cellInfo.component.closeEditCell()
    },
    itemTemplateHr(data) {
      // 특정 조건에 따라 글자에 중앙줄을 적용하는 사용자 정의 템플릿
      if (data.hrUseYn === 'N') {
        return `<div style="text-decoration: line-through;">${data.korNm}</div>`
      } else {
        return `<div>${data.korNm}</div>`
      }
    },
    ///////////////////////////////////////
    /*             etc Event             */
    ///////////////////////////////////////
    // html단에 쓰기 위함
    getDateToTime(e) {
      return getDateToTime(e)
    },
    deleteCallBack(selectedRows) {
      var index = null
      selectedRows.forEach(key => {
        index = this.gridMain.findIndex(obj => obj == key)
        this.gridMain.splice(index, 1)
      })
    },
    getLookupData() {
      this.openLoading()

      Promise.all([
        getCommonCode('C0045'),
        getCommonCode('C0046'),
        getCommonCode('C0053'),
        getCheckIdLookup({ compId: this.getCompId() }),
        getMuscleSymptonHrInfo({ compId: this.getCompId() }),
        getMuscleSymptonHrSearchInfo({ compId: this.getCompId() })
      ])
        .then(response => {
          this.searchGubnList = response[0].list //조사구분(공통코드:C0045)
          this.occanCuaseList = response[1].list //수시작업시 사유(공통코드:C0046)
          this.deptCodeList = response[2].list //부서명(공통코드:C0053)
          this.proDataSource = response[3].list.filter(element => element.grouped === '3. 공정') //작업공정명
          this.hrList = response[4].list.slice() // 근로자
          this.hrListForSearch = response[5].list.slice()

          //조사구분
          this.selectDiv = []
          this.selectDiv = this.searchGubnList.slice()
          this.selectDiv.unshift({ minorCd: '', minorNm: '전체' })
        })
        .finally(() => {
          this.endLoading()
        })
    },
    saveFile(selectedDetailRows) {
      return new Promise((resolve, reject) => {
        selectedDetailRows.forEach(element => {
          var formData = new FormData()

          formData.append('files[]', element.file)

          let fileVO = {
            fileId: null,
            targetId: element.targetId,
            targetType: element.targetType,
            useYn: element.useYn
          }

          if (!element.__created__) {
            fileVO.fileId = element.fileId
          }

          formData.append('FileVO', new Blob([JSON.stringify(fileVO)], { type: 'application/json' }))
          multiUpload(formData, true)
            .then(res => {
              let index = this.templates.findIndex(e => e.classifNo === element.targetId)
              this.GetDataGrid(this.dxDataGridRef).cellValue(index + 1, 'fileYn', 'Y')
              this.GetDataGrid(this.dxDataGridRef).saveEditData()

              this.DetailInit()
            })
            .catch(error => {})
            .finally(() => {
              resolve(true)
            })
        })
      })
    },
    onFocusedMasterChanged(data) {
      this.GetDataGrid(this.dxDataGridRef).option('focusedRowIndex', data.rowIndex - 1)
    },
    onEditorPreparing(e) {
      var valueChanged = this.onCellValueChanged

      if (e.parentType == 'dataRow') {
        e.editorOptions.onValueChanged = args => {
          if (e.index > -1) {
            valueChanged(args.value, e)
          }
        }
      }
    },
    async onCellValueChanged(value, cellInfo) {
      cellInfo.setValue(value)
      cellInfo.component.selectRows(cellInfo.row.key, true)

      //조사구분이 정기점검인 경우, 수시작업 사유 초기화
      if (cellInfo.dataField == 'searchGubn' && value == 'regular') {
        this.GetDataGrid(this.dxDataGridRef).cellValue(cellInfo.row.rowIndex, 'occanCuase', null)
      }
    },
    onEditingStart(e) {
      if (
        (e.column.dataField == 'situationFacilityContent' && e.data.situationFacilityYn == 'N') || //작업장상황조사(작업설비)
        (e.column.dataField == 'situationWorkloadContent' && e.data.situationWorkloadYn == 'N') || //작업장상황조사(작업량)
        (e.column.dataField == 'situationWorkspeedContent' && e.data.situationWorkspeedYn == 'N') || //작업장상황조사(작업속도)
        (e.column.dataField == 'situationWorktypeContent' && e.data.situationWorktypeYn == 'N') || //작업장상황조사(업무형태)
        (e.column.dataField == 'situationWorketcContent' && e.data.situationWorketcYn == 'N') || //작업장상황조사(기타)
        (e.column.dataField == 'occanCuase' && e.data.searchGubn == 'regular') //수시작업 사유, 정기점검일 경우
      ) {
        e.cancel = true
      }
    },
    onFocusedRowChanged(e) {
      if (e.rowIndex > -1) {
        this.$emit('focused-changed', e.row.data)
      }
    },
    changeInput(value) {
      this.GetDataGrid(this.dxDataGridRef).searchByText(value)
    },
    onDateValueChanged(event, cellInfo) {
      //날짜 세팅
      const date = new Date(event.value)
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const dateFormat = `${year}.${month}.${day}`

      //그리드 삽입
      const cell = this.gridMain[cellInfo.rowIndex]
      cell[cellInfo.column.dataField] = dateFormat
      cellInfo.setValue(dateFormat)
      this.$refs[this.dxDataGridRef].instance.selectRows(cellInfo.row.key, true)
    }
  }
}
</script>

<style lang="scss">
.dx-command-select {
  width: 30px !important;
  min-width: 30px !important;
}
</style>
